export default __webpack_public_path__ + "assets/images/rules-6f46e2fca9669c24642609f9c17754d0.svg";